import { Transition } from '@headlessui/react';
import { useState } from 'react';
import { classNames } from '~/utils/styles';
import { Icon } from '../icon';
import type { CollapsibleSectionProps } from './CollapsibleSection.types';

export function CollapsibleSection({
  children,
  className,
  defaultExpanded = true,
  title,
  titleClassName,
}: CollapsibleSectionProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  function handleToggle() {
    setIsExpanded((prev) => !prev);
  }

  return (
    <div className={classNames('w-full', className)}>
      <button
        className={classNames('flex w-full items-center justify-between gap-2 text-left', titleClassName)}
        onClick={handleToggle}
        type="button"
      >
        <span className="body-200-heavy flex-1">{title}</span>
        <Icon height={16} icon="ArrowDropDownLineIcon" width={16} />
      </button>

      <Transition
        as="div"
        className="overflow-hidden"
        enter="transition-all duration-200 ease-out"
        enterFrom="opacity-0 max-h-0"
        enterTo="opacity-100 max-h-[1000px]"
        leave="transition-all duration-200 ease-in"
        leaveFrom="opacity-100 max-h-[1000px]"
        leaveTo="opacity-0 max-h-0"
        show={isExpanded}
      >
        <div className="pt-2">{children}</div>
      </Transition>
    </div>
  );
}
